import React from 'react';
import PaymentStep from '../../components/ContractSteps/PaymentStep';
import SearchPage from './steps/SearchPage';
import SignerStep from '../../components/ContractSteps/SignerStep';
import CalculationStep from './steps/CalculationStep';

import ProfileIcon from '../../icons/Profile';
import CalculatorIcon from '../../icons/Calculator';
import CardIcon from '../../icons/Card';

export const stepsId = {
  signer: 'signer',
  search: 'search',
  calculator: 'calculator',
  payment: 'payment',
  confirmation: 'confirmation',
};

export default [
  {
    n: 1,
    iconName: '',
    icon: <ProfileIcon />,
    id: stepsId.signer,
    label: 'contract.steps.signer',
    content: (data) => {
      const props = data;
      props.params.hasLanguageSensitiveNames = true;
      props.params.hasAddressInputsLanguageSensitiveNames = true;

      return <SignerStep {...props} />;
    },
  },
  {
    n: 2,
    iconName: '',
    icon: <ProfileIcon />,
    id: stepsId.search,
    label: 'contract.steps.search',
    content: (props) => <SearchPage {...props} />,
  },
  {
    n: 3,
    iconName: '',
    icon: <CalculatorIcon />,
    id: stepsId.calculator,
    label: 'contract.steps.calculator',
    content: (props) => <CalculationStep {...props} />,
  },
  {
    n: 4,
    iconName: '',
    icon: <CardIcon />,
    id: stepsId.payment,
    label: 'contract.steps.payment',
    content: PaymentStep,
  },
  {
    n: 5,
    iconName: 'checkmark',
    icon: null,
    id: stepsId.confirmation,
    label: 'contract.steps.confirmation',
    content: () => <></>,
  },
];
